import { ClockCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { Steps, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { useTimesheet } from '../../hooks';
import { STEP_DESCRIPTIONS,COUNTRY_VALUE } from './constants';
const { Step } = Steps;

const employeeStepStatuses = {
  submitting: {
    icon: <SyncOutlined spin />,
    color: 'processing',
    title: 'Submitting',
    isCurrent: true
  },
  submitted: {
    color: 'success',
    title: 'Submitted',
    isCurrent: false
  }
};

const projectDirectorStepStatuses = {
  waiting: {
    icon: <ClockCircleOutlined />,
    color: 'default',
    title: 'Waiting',
    isCurrent: false
  },
  processing: {
    icon: <SyncOutlined spin />,
    color: 'processing',
    title: 'Reviewing',
    isCurrent: true
  },
  rejected: {
    color: 'error',
    title: 'Rejected',
    isCurrent: false
  },
  done: {
    color: 'success',
    title: 'Reviewed',
    isCurrent: false
  }
};

const directManagerStepStatuses = {
  waiting: {
    icon: <ClockCircleOutlined />,
    color: 'default',
    title: 'Waiting',
    isCurrent: false
  },
  processing: {
    icon: <SyncOutlined spin />,
    color: 'processing',
    title: 'Processing',
    isCurrent: true
  },
  rejected: {
    color: 'error',
    title: 'Rejected',
    isCurrent: false
  },
  approved: {
    color: 'success',
    title: 'Approved',
    isCurrent: true
  }
};

const getSteps = (timesheet, isDraft, isApproved, timesheetAutoReview,TimesheetStatus,Find_country) => {
  const getEmployeeStep = () =>
    !timesheet || isDraft || isApproved === 0 ? employeeStepStatuses['submitting'] : employeeStepStatuses['submitted'];
  const getEmployeeMessage = () => (isDraft ? 'This timesheet is a draft' : null);

  const allEntriesReviewed = timesheet?.reviewedByProjectDirector;
  const CheckApproved=timesheet?.timeSheetEntryPerActivities;
  

  let PM_ApproveStatus = 0;

const checkPMStatus = () => {
  if (!CheckApproved?.length) return;
  const Line_Manager_Reject = CheckApproved.some(item => item?.isReviewedByLineManager ==false);
  const hasRejected = CheckApproved.some(item => item?.is_approved === TimesheetStatus.PM_REJECTED);
  if (hasRejected || Line_Manager_Reject) {
    PM_ApproveStatus = TimesheetStatus.PM_REJECTED;
    return;
  }

  const notApprovedCount = CheckApproved.filter(item => item?.is_approved === TimesheetStatus.SUBMITTED).length;
  PM_ApproveStatus = notApprovedCount === TimesheetStatus.SUBMITTED ? TimesheetStatus.PM_APPROVED : TimesheetStatus.SUBMITTED;
};

  
checkPMStatus()
  const getProjectDirectorStep = () => {
    if (PM_ApproveStatus === TimesheetStatus.PM_REJECTED && !LineMangerStatus()) return projectDirectorStepStatuses['rejected'];
    if (LineMangerStatus()) { return projectDirectorStepStatuses['done']}
    if (allEntriesReviewed) return projectDirectorStepStatuses['done'];
    if (!timesheet || isDraft )
      return projectDirectorStepStatuses['waiting'];
    if (!allEntriesReviewed || (PM_ApproveStatus == TimesheetStatus.SUBMITTED )) return projectDirectorStepStatuses['processing'];
    return projectDirectorStepStatuses['done'];
  };

  const getDirectManagerStep = () => {
 
    if (PM_ApproveStatus===TimesheetStatus.PM_APPROVED && isApproved === 0) return directManagerStepStatuses['rejected'];
    if (LineMangerStatus()==true && PM_ApproveStatus==TimesheetStatus.PM_REJECTED) return directManagerStepStatuses['rejected']
    if ((!timesheet || isDraft || !allEntriesReviewed) && isApproved!==1) return directManagerStepStatuses['waiting'];
    if (isApproved && !isDraft) return directManagerStepStatuses['approved'];
    if (timesheet && !isDraft && allEntriesReviewed) return directManagerStepStatuses['processing'];
    return '';
  };

  const LineMangerStatus=()=>{
   
    const iswaitingLinemangerStatus = timesheet?.areAllWaiting == false ? false : CheckApproved?.every(check => check.isReviewedByLineManager);
    return iswaitingLinemangerStatus
    
  }
  return [
    { ...getEmployeeStep(), description: getEmployeeMessage() },
    ...(Find_country === COUNTRY_VALUE.INDIA
    ? [{ ...getProjectDirectorStep(), description: STEP_DESCRIPTIONS.APPROVER_1 }]
    : !timesheetAutoReview
    ? [{ ...getProjectDirectorStep(), description: STEP_DESCRIPTIONS.PROJECT_MANAGER }]
    : []
    ),

    ...(Find_country === COUNTRY_VALUE.INDIA
    ? [{ ...getDirectManagerStep(), description: STEP_DESCRIPTIONS.APPROVER_2 }]
    : !timesheetAutoReview
    ? [{ ...getDirectManagerStep(), description: STEP_DESCRIPTIONS.LINE_MANAGER }]
    : []
    ),
    
  ];
};




export const TimesheetTimeline = () => {
  const { timesheet } = useTimesheet();

  const timesheetAutoReview = useSelector((state) => state.appConfiguration.timesheetAutoReview);
  const TimesheetStatus=useSelector((state)=>{
    return state.employees.TimesheetStatus
  })
  const Find_country=useSelector((state)=>{
  return state.appConfiguration.entityCode
})

  
  const steps = getSteps(timesheet, timesheet?.isDraft, timesheet?.isApproved, timesheetAutoReview,TimesheetStatus,Find_country);
  const activeStep = timesheet?.isApproved ? steps.length : steps.findIndex((step) => step.isCurrent);

  // this one is controlled by isDraft in status 3 and 0
  return (
    <Steps current={activeStep} size={'small'}>
      {steps.map((step, index) => (
        <Step
          key={index}
          title={
            <Tag icon={step.icon} color={step.color}>
              {step.title}
            </Tag>
          }
          description={step.description}
        />
      ))}
      {/* <Step title={DirectManagerStep} description="Line Manager Decision" /> */}
    </Steps>
  );
};
